'use strict';

exports.__esModule = true;
var BLINK = exports.BLINK = 'react-hold-animation__blink';

var SPREAD = exports.SPREAD = 'react-hold-animation__spread';

var SLIDE = exports.SLIDE = 'react-hold-animation__slide';


//////////////////
// WEBPACK FOOTER
// ./~/react-hold-animation/lib/modes.js
// module id = 194
// module chunks = 0